import { render, staticRenderFns } from "./RelatedVariantsTab.vue?vue&type=template&id=3197d5eb&"
import script from "./RelatedVariantsTab.vue?vue&type=script&lang=ts&"
export * from "./RelatedVariantsTab.vue?vue&type=script&lang=ts&"
import style0 from "./RelatedVariantsTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports